import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface GlobalState {
  opened: boolean;
  folded: boolean;
  mobileOpened: boolean;
  dialogs: string[];
}

const initialState: GlobalState = {
  opened: true,
  folded: false,
  mobileOpened: false,
  dialogs: [],
};

const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    toggleNarvarAction: (state) => {
      state.opened = !state.opened;
    },
    openNarvarAction: (state) => {
      state.opened = true;
    },
    closeNarvarAction: (state) => {
      state.opened = false;
    },
    foldNarvarAction: (state) => {
      state.folded = true;
    },
    unfoldNarvarAction: (state) => {
      state.folded = false;
    },
    toggleMobileNarvarAction: (state) => {
      state.mobileOpened = !state.mobileOpened;
    },
    openMobileNarvarAction: (state) => {
      state.mobileOpened = true;
    },
    closeMobileNarvarAction: (state) => {
      state.mobileOpened = false;
    },
    openDialogAction: (state, action: PayloadAction<string>) => {
      state.dialogs = [
        ...(Array.isArray(state.dialogs) ? state.dialogs : []),
        action.payload,
      ];
    },
    closeDialogAction: (state, action: PayloadAction<string>) => {
      state.dialogs = (Array.isArray(state.dialogs) ? state.dialogs : []).filter((dialog) => dialog !== action.payload);
    },
    closeAllDialogAction: (state) => {
      state.dialogs = [];
    },
    globalClearAction: (state) => {
      state.opened = true;
      state.folded = false;
      state.mobileOpened = false;
      state.dialogs = [];
    },
  },
});

export const {
  toggleNarvarAction,
  openNarvarAction,
  closeNarvarAction,
  foldNarvarAction,
  unfoldNarvarAction,
  toggleMobileNarvarAction,
  openMobileNarvarAction,
  closeMobileNarvarAction,
  openDialogAction,
  closeDialogAction,
  closeAllDialogAction,
  globalClearAction,
} = globalSlice.actions;

export default globalSlice.reducer;
